module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("MAYBE THEN SHE'LL REALIZE THAT SOME GIRLS DO")]), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“SOME GIRLS DO…and some girls do it better. Leanne Banks pens a winner. Sexy and laugh-out-loud fun!”")]), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—"), _c('strong', [_vm._v("Kasey Michaels, author of "), _c('em', [_vm._v("The Kissing Game")])])]), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“A master of love and laughter, Ms. Banks delights both heart and soul.”")]), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—"), _c('strong', [_c('em', [_vm._v("Romantic Times")])])]), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Leanne Banks is clearly a master.”")]), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—"), _c('strong', [_c('em', [_vm._v("Romance Reader")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc7d185c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SomeGirlsDo_fron-1.vue
// module id = 72
// module chunks = 0